import AccountCreateComponent from "../../../components/admin/account/AccountCreateComponent";

const AccountCreate = () => {
  return <AccountCreateComponent />;
};

export default AccountCreate;
